import React, { useState, useEffect } from "react";
// import { NavLink } from "react-router";
import { Global } from "../helpers/Global";
import { Peticion } from "../helpers/Peticion";

export const Blog = () => {

    const entrada = 0

   const [posts, setPosts] = useState([]);

    const getPosts = async () => {
         let { datos } = await Peticion(Global.url + "blog/posts/", "GET");
     
         if (datos) {
           setPosts(datos.data);
         }
       };
   
        useEffect(() => {
           getPosts();
         }, []);

  return (
        <section class="content__page content__blog">
         {/* contenido de blog  */}
            <header class="blog__header">
                <h1 class="blog__title">Blog</h1>
            </header>
            {posts.map((post) => {
                return(
                    <section class="blog__articles">      
                        <article class="articles__article">
                            <div class="article__top">
                                <div class="article__category">
                                </div>
                                <a href="#"
                                class="article__image-link">
                                    <div class="article__mark">
                                        <img src={ Global.media + post.image }
                                            class="article__image"
                                            alt={ post.title } />
                                    </div>
                                    <div class="article__logo">
                                        <i class="article__icon fa-solid fa-book"></i>
                                    </div>
                                </a>
                            </div>
                            <div class="article__botton">
                                <time class="article__date" datetime="2024-08-12">{ post.published_date }</time>
                                <a href="#" class="article__link">
                                    <h3 class="article__title">{ post.title }</h3>
                                </a>
                            </div>
                        </article>
                
                    {/* <p class="articles__info">No hay articulos que mostrar...</p> */}
            
            </section>
                );
            })}
            
        </section>
     );
    };
    